import { API } from '../../http';

const getUsers = async () => {
  return await API.get('/users');
};

const createUser = async (
  user = { name: null, username: null, email: null, password: null }
) => {
  return await API.post('/users', user);
};

const patchUser = async (id, status) => {
  return await API.patch(`/users/${id}`, { status });
};

const usersServices = {
  getUsers,
  createUser,
  patchUser,
};

export default usersServices;
